var modalServerHost = "https://clutch-customers-followup.vercel.app";
var modalFormWebhook = "/form";
var modalRequestUrl = modalServerHost + modalFormWebhook;

document.addEventListener('DOMContentLoaded', function() {
    const popup = document.getElementById('popup1');
    const closeBtn = popup.querySelector('.close');
    const THIRTY_DAYS_IN_MS = 30 * 24 * 60 * 60 * 1000;

    function showPopup() {
        popup.classList.add('active');
    }

    function hidePopup() {
        popup.classList.remove('active');
        localStorage.setItem('lastCloseTime', Date.now().toString());
    }

    closeBtn.addEventListener('click', hidePopup);

    const lastCloseTime = localStorage.getItem('lastCloseTime');
    const currentTime = Date.now();
    if (!lastCloseTime || (currentTime - parseInt(lastCloseTime)) > THIRTY_DAYS_IN_MS) {
        showPopup();
    }
});

function copyDiscountCode() {
    const codeElement = document.getElementById('discountCode');
    const messageElement = document.getElementById('copyMessage');
    
    // Create a temporary textarea element to copy the text
    const textarea = document.createElement('textarea');
    textarea.value = codeElement.textContent;
    document.body.appendChild(textarea);
    textarea.select();
    
    try {
        // Execute the copy command
        document.execCommand('copy');
        
        // Show the success message
        messageElement.style.display = 'inline';
        
        // Hide the message after 2 seconds
        setTimeout(() => {
            messageElement.style.display = 'none';
        }, 2000);
    } catch (err) {
        console.error('Failed to copy text:', err);
    } finally {
        // Clean up
        document.body.removeChild(textarea);
    }
}

function nextStep(step, errorMessage = '') {
    document.querySelectorAll('.step').forEach(s => s.classList.remove('active'));
    const nextStepElement = document.getElementById('step' + step);
    if (step === 4 && errorMessage) {
        const errorContainer = nextStepElement.querySelector('.server-error-message');
        if (errorContainer) {
            errorContainer.innerHTML = errorMessage;
        }
    }
    nextStepElement.classList.add('active');
}

async function submitForm() {
    const email = document.getElementById('email').value;
    const phone = document.getElementById('phone').value;

    var loadingDiv = document.createElement('div');
    loadingDiv.innerHTML = `<span style="border: 6px solid #ffffff; border-radius: 50%; border-top: 6px solid #000000; width: 50px; height: 50px; -webkit-animation: spin 2s linear infinite; animation: spin 1s linear infinite;"></span>`;
    loadingDiv.style.cssText = `position: fixed; background: rgba(0,0,0,0.5); width: 100%; top: 0; bottom: 0; color: white; z-index: 10001; text-align: center; display: flex; flex-wrap: wrap; align-items: center; justify-content: center;`;
    document.body.appendChild(loadingDiv);

    try {
        const response = await fetch(modalRequestUrl, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                phone: phone,
                firstName: email,
                tags: "discountSubscription",
            })
        });
        
        const resData = await response.json();
        if (resData.status == 200) {
            nextStep(3); // Success
        } else { 
            nextStep(4, resData.htmlMessage); // Pass error message to nextStep
        }
    } catch (error) {
        console.error('Error sending data to webhook:', error);
        nextStep(4, '<div class="error_box" style="margin-bottom: 10px; border: 1px solid red; padding: 10px;"><p style="color: red;">An unexpected error occurred. Please try again later.</p></div>');
    } finally {
        loadingDiv.remove();
    }
}

function hidePopup(lastCloseTime=true) {
    const popup = document.getElementById('popup1');
    popup.classList.remove('active');
    if(lastCloseTime){
        localStorage.setItem('lastCloseTime', Date.now().toString());
    }
}